const ITEMS = [
    "Artificial Turf",
    "Backyard Putting Greens",
    "Pet & Play Areas",
    "Boise",
    "Meridian",
    "Nampa",
    "Eagle",
    "Caldwell",
    "Kuna",
    "Star",
];

export const Marquee = () => {
    const row = [...ITEMS, ...ITEMS];
    return (
        <div
            data-testid="editorial-marquee"
            aria-hidden="true"
            className="relative overflow-hidden border-y border-brand-border bg-white py-6 md:py-8"
        >
            <div className="flex w-max animate-marquee items-center">
                {row.map((item, i) => (
                    <span key={i} className="flex shrink-0 items-center">
                        <span
                            className={`whitespace-nowrap px-8 text-2xl md:px-12 md:text-4xl ${
                                i % 2 === 0
                                    ? "font-display font-light italic text-brand-text"
                                    : "font-sans font-bold uppercase tracking-[0.18em] text-brand-muted/70"
                            }`}
                        >
                            {item}
                        </span>
                        <span
                            aria-hidden
                            className="h-1.5 w-1.5 rounded-full bg-brand-accent/70"
                        />
                    </span>
                ))}
            </div>
        </div>
    );
};
